
import { mapGetters } from 'vuex';
import { TRANSPARENT_IMAGE_URL } from '@/constants/IMAGE_URLS';
import SocialMediaType from '@/enums/SocialMediaType';
import SocialMediaLinkBar from './SocialMediaLinkBar';
import EmbeddedSocialMediaReviewPc from './EmbeddedSocialMediaReviewPc';

export default {
  i18nComponentKey: 'ReviewsShow.components.ReviewMediaSectionPc',
  name: 'ReviewMediaSectionPc',
  components: {
    SocialMediaLinkBar,
    EmbeddedSocialMediaReviewPc
  },
  model: {
    prop: 'mediaPosition',
    event: 'change'
  },
  props: {
    review: { type: Object, default: null },
    mediaPosition: { type: Number, default: 1 }
  },
  computed: {
    ...mapGetters('review', ['isEmbeddedSocialMediaType']),
    isSocialMediaType() {
      return this.review.social_media_type !== SocialMediaType.NONE;
    },
    videoSrc() {
      const videoIdx = this.mediaPosition ? this.mediaPosition - 1 : 0;
      return this.review.videos[videoIdx]?.url;
    },
    imageSrc() {
      const imageIdx = this.mediaPosition
        ? this.mediaPosition - this.review.videos.length - 1
        : 0;
      return this.review.images[imageIdx]?.url || TRANSPARENT_IMAGE_URL;
    }
  }
};
